import React from 'react';

import { TextProps } from '@rbilabs/universal-components';

import { A11yWrapper } from 'components/a11y-wrapper';
import { t } from 'state/intl/translations';

import { Total, TotalLabel, TotalsRow } from './styled';

export const TaxesAndFeesNextStep: React.FC<React.PropsWithChildren<{ textProps?: TextProps }>> = ({
  textProps,
}) => {
  return (
    <TotalsRow {...textProps}>
      <A11yWrapper>
        <TotalLabel {...(textProps && { fontSize: 'sm' })}>{t('taxesAndFees')}</TotalLabel>
      </A11yWrapper>
      <Total {...(textProps && { fontSize: 'sm' })} testID="totalTax">
        {t('taxesAndFeesNextStep')}
      </Total>
    </TotalsRow>
  );
};
